<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <div class="logo-icon"></div>
        <!-- <span class="logo-text secondary-text">CMS</span> -->
    </div>

    <div class="buttons" style="height: 30px;">
        <form [formGroup]="form">
            <div class="group">
                <!-- <mat-radio-group fxLayout="column" fxLayoutAlign="start start" formControlName="colorTheme">
                    <mat-radio-button class="mb-12" value="theme-default" >Default Light</mat-radio-button>
                    <mat-radio-button class="mb-12" value="theme-blue-gray-dark">Dark Mode</mat-radio-button>
                </mat-radio-group> -->
                <mat-slide-toggle (change)="toggleCollapsed($event)" [checked]="toggleChecked">
                </mat-slide-toggle>&nbsp;&nbsp;
                <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
                    <mat-icon class="secondary-text">menu</mat-icon>
                </button>
                <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
                    <mat-icon class="secondary-text">arrow_back</mat-icon>
                </button>

            </div>

        </form>


    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <!-- <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

        <div class="h3 username">Charlie Adams</div>
        <div class="h5 email hint-text mt-8">adams.charlie@mail.com</div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="assets/images/avatars/Velazquez.jpg">
        </div>

    </div> -->

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

</div>